import type * as Types from 'app/types/graphql';

import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type VariantUrlDeleteMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type VariantUrlDeleteMutationResponse = Pick<Types.Mutation, 'variantURLDelete'>;

export const VariantUrlDeleteDocument = `
    mutation VariantURLDelete($id: ID!) {
  variantURLDelete(id: $id)
}
    `;

export const useVariantUrlDeleteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    VariantUrlDeleteMutationResponse,
    TError,
    VariantUrlDeleteMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    VariantUrlDeleteMutationResponse,
    TError,
    VariantUrlDeleteMutationVariables,
    TContext
  >(
    ['VariantURLDelete'],
    (variables?: VariantUrlDeleteMutationVariables) =>
      appFetcher<VariantUrlDeleteMutationResponse, VariantUrlDeleteMutationVariables>(
        VariantUrlDeleteDocument,
        variables,
      )(),
    options,
  );
};

useVariantUrlDeleteMutation.getKey = () => ['VariantURLDelete'];
